import script from "./Notes.vue?vue&type=script&setup=true&lang=js"
export * from "./Notes.vue?vue&type=script&setup=true&lang=js"

import "./Notes.vue?vue&type=style&index=0&id=19585c67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19585c67"]])

export default __exports__